import script from "./AccordionBlockItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionBlockItem.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionBlockItem.vue?vue&type=style&index=0&id=4e7e9d4b&lang=scss"

const __exports__ = script;

export default __exports__